<template>
  <div :class="{fullscreen:fullscreen}" class="tinymce-container editor-container">
    <textarea :id="tinymceId" class="tinymce-textarea" />
    <!-- <div class="editor-custom-btn-container">
      <editorImage color="#1890ff" class="editor-upload-btn" @successCBK="imageSuccessCBK" />
    </div> -->
  </div>
</template>

<script>
import editorImage from './components/editorImage'
import plugins from './plugins'
import toolbar from './toolbar'

export default {
  name: 'Tinymce',
  components: { editorImage },
  props: {
    id: {
      type: String,
      default: function() {
        return 'vue-tinymce-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '')
      }
    },
    value: {
      type: String,
      default: ''
    },
    toolbar: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    menubar: {
      type: String,
      default: 'file edit insert view format table'
    },
    height: {
      type: Number,
      required: false,
      default: 600
    }
  },
  data() {
    return {
      hasChange: false,
      hasInit: false,
      tinymceId: this.id,
      fullscreen: false,
      languageTypeList: {
        'en': 'en',
        'zh': 'zh_CN'
      }
    }
  },
  computed: {
    language() {
      return this.languageTypeList[this.$store.getters.language]
    }
  },
  watch: {
    value(val) {
      if (!this.hasChange && this.hasInit) {
        this.$nextTick(() =>
          window.tinymce.get(this.tinymceId).setContent(val || ''))
      }
    },
    language() {
      this.destroyTinymce()
      this.$nextTick(() => this.initTinymce())
    }
  },
  mounted() {
    this.initTinymce()
  },
  activated() {
    this.initTinymce()
  },
  deactivated() {
    this.destroyTinymce()
  },
  destroyed() {
    this.destroyTinymce()
  },
  methods: {
    initTinymce() {
      const _this = this
      window.tinymce.init({
        language: this.language,
        selector: `#${this.tinymceId}`,
        height: 600,
        body_class: 'panel-body ',
        object_resizing: false,
        branding: true, //是否禁用“Powered by TinyMCE”
        // toolbar: this.toolbar.length > 0 ? this.toolbar : toolbar,
        toolbar: ["preview code bold italic underline strikethrough forecolor backcolor blocks fontfamily fontsize cut copy link image media table bullist numlist  alignleft aligncenter alignright alignjustify outdent indent blockquote subscript superscript removeformat undo redo indent2em"],
        menubar: this.menubar,
        menubar: false, //顶部菜单栏显示,
        media_live_embeds: true,
        // 视频上传回调自定义
        // video_template_callback: function(data) {
        //   // console.log(data)
        //   // return '<video width="' + data.width + '" height="' + data.height + '"' + (data.poster ? ' poster="' + data.poster + '"' : '') + ' controls="controls">\n' + '<source src="' + data.source + '"' + (data.sourcemime ? ' type="' + data.sourcemime + '"' : '') + ' />\n' + (data.altsource ? '<source src="' + data.altsource + '"' + (data.altsourcemime ? ' type="' + data.altsourcemime + '"' : '') + ' />\n' : '') + '</video>';
        // },
        //自定义逻辑替换 Tinymce 的默认媒体嵌入逻辑
        //https://blog.csdn.net/xh17864388739/article/details/111182931
        // plugins: plugins,
        plugins: [
          "code",
          "link",
          "table",
          "advlist",
          "lists",
          "image",
          "preview",
          "indent2em",
          "media"
        ], //选择需加载的插件
        end_container_on_empty_block: true,
        powerpaste_word_import: 'clean',
        code_dialog_height: 450,
        code_dialog_width: 1000,
        advlist_bullet_styles: 'square',
        advlist_number_styles: 'default',
        // imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
        default_link_target: '_blank',
        link_title: false,
        nonbreaking_force_tab: true, // inserting nonbreaking space &nbsp; need Nonbreaking Space Plugin
        // images_upload_url: 'postAcceptor.php', //图片上传的接口地址
        file_picker_types: 'media,image',
        // 文件上传
        file_picker_callback: function(callback, value, meta) {
          //要先模拟出一个input用于上传本地文件
          var input = document.createElement("input");
          input.setAttribute("type", "file");
          //你可以给input加accept属性来限制上传的文件类型
          input.setAttribute(
            "accept",
            ".jpg,.png,.gif,.jpeg,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt,.md,.rar,.zip,.mp4"
          );
          console.log('1111111')
          input.click();
          input.onchange = function() {
            var file = this.files[0];
            var xhr, formData;
            console.log(file);
            function ajax(){
                var LENGTH = 1024 * 1024 * 10; //每次上传的大小
                var totalSize = file.size; //文件总大小
                var start = 0; //每次上传的开始字节
                var end = start + LENGTH; //每次上传的结尾字节
                var blob = null; //二进制对象
                var fd = null; //创建表单数据对象
                var xhr = null; //xhr对象
                var response = null;
                while (start < totalSize) {
                    fd = new FormData(); //每一次需要重新创建
                    xhr = new XMLHttpRequest(); //需要每次创建并设置参数
                    xhr.open("POST", process.env.VUE_APP_BASE_API + "/upload/bigfile", false);
                    blob = file.slice(start, end); //根据长度截取每次需要上传的数据
                    //重新设置开始和结尾
                    // console.log(fd);
                    fd.append("video", blob); //添加数据到fd对象中
                    fd.append("filename", file.name); //获取文件的名称
                    if (end >= totalSize) {
                    fd.append("is_last", 1);
                    } else {
                    fd.append("is_last", 0);
                    }
                    _this.loadStatus = true
                    xhr.send(fd); //将fd数据上传
                    response = JSON.parse(xhr.response);
                    if (response.code != 200) {
                        _this.$message({
                            showClose: true,
                            message: '上传失败，请检查网络及上传的内容是否符合要求！',
                            type: 'warning'
                        });
                        _this.loadStatus = false
                        return;
                    } 
                    start = end;
                    end = start + LENGTH;
                    // console.log('上传了文件');
                }
                _this.loadStatus = false
                console.log('response:',response)
                callback(
                  _this.$publicData.imgUrl + response.result.url
                );
                // _this.$publicData.imgUrl + response.result.url
            }
            setTimeout(function(){
                ajax()
            },300)
            // xhr = new XMLHttpRequest();
            // xhr.withCredentials = false;
            // xhr.open("POST", process.env.VUE_APP_BASE_API + "/common/uploadFile");
            // xhr.onload = function() {
            //   var json;
            //   if (xhr.status != 200) {
            //     failure("HTTP Error: " + xhr.status);
            //     return;
            //   }
            //   json = JSON.parse(xhr.responseText);
            //   if (!json || json.code != 200) {
            //     failure("上传失败: " + json.message);
            //     return;
            //   }
            //   // 成功了的处理
              // callback(
              //   _this.$publicData.imgUrl + json.result.url
              // );
            // };
            // formData = new FormData();
            // formData.append("imgFile", file, file.name);
            // xhr.send(formData);
          };
        },
        onSuccess(response,) {
            _this.$publicData.imgUrl + json.result.url
        },
        init_instance_callback: editor => {
          if (_this.value) {
            editor.setContent(_this.value)
          }
          _this.hasInit = true
          editor.on('NodeChange Change KeyUp SetContent', () => {
            this.hasChange = true
            this.$emit('input', editor.getContent())
          })
        },
        setup(editor) {
          editor.on('FullscreenStateChanged', (e) => {
            _this.fullscreen = e.state
          })
        },
        // 整合七牛上传
        // images_dataimg_filter(img) {
        //   setTimeout(() => {
        //     const $image = $(img);
        //     $image.removeAttr('width');
        //     $image.removeAttr('height');
        //     if ($image[0].height && $image[0].width) {
        //       $image.attr('data-wscntype', 'image');
        //       $image.attr('data-wscnh', $image[0].height);
        //       $image.attr('data-wscnw', $image[0].width);
        //       $image.addClass('wscnph');
        //     }
        //   }, 0);
        //   return img
        // },
        // 自己处理上传图片
        images_upload_handler:function (blobInfo, progress){
          return new Promise((resolve, reject) => {
            var xhr, formData;
            var file = blobInfo.blob(); //转化为易于理解的file对象
            xhr = new XMLHttpRequest();
            xhr.withCredentials = false;
            xhr.open("POST", process.env.VUE_APP_BASE_API + "/common/uploadFile");
            xhr.onload = function() {
              var json;
              if (xhr.status != 200) {
                failFun("HTTP Error: " + xhr.status);
                return;
              }
              json = JSON.parse(xhr.responseText);
              if (!json || json.code != 200) {
                failFun("上传失败: " + json.message);
                return;
              }
              resolve(_this.$publicData.imgUrl + json.result.url)
            };
            formData = new FormData();
            formData.append("imgFile", file, file.name); //此处与源文档不一样
            xhr.send(formData);
          })
        },
        // images_upload_handler: function(blobInfo, succFun, failFun) {
        //   var xhr, formData;
        //   var file = blobInfo.blob(); //转化为易于理解的file对象
        //   xhr = new XMLHttpRequest();
        //   xhr.withCredentials = false;
        //   xhr.open("POST", process.env.VUE_APP_BASE_API + "/common/uploadFile");
        //   xhr.onload = function() {
        //     var json;
        //     if (xhr.status != 200) {
        //       failFun("HTTP Error: " + xhr.status);
        //       return;
        //     }
        //     json = JSON.parse(xhr.responseText);
        //     if (!json || json.code != 200) {
        //       failFun("上传失败: " + json.message);
        //       return;
        //     }
        //     // 成功了的处理
        //     succFun(
        //       _this.$publicData.imgUrl + json.result.url
        //     );
        //   };
        //   formData = new FormData();
        //   formData.append("imgFile", file, file.name); //此处与源文档不一样
        //   xhr.send(formData);
        // },
        // images_upload_handler(blobInfo, success, failure, progress) {
        //   progress(0);
        //   const token = _this.$store.getters.token;
        //   getToken(token).then(response => {
        //     const url = response.data.qiniu_url;
        //     const formData = new FormData();
        //     formData.append('token', response.data.qiniu_token);
        //     formData.append('key', response.data.qiniu_key);
        //     formData.append('file', blobInfo.blob(), url);
        //     upload(formData).then(() => {
        //       success(url);
        //       progress(100);
        //     })
        //   }).catch(err => {
        //     failure('出现未知问题，刷新页面，或者联系程序员')
        //     console.log(err);
        //   });
        // },
      })
    },
    destroyTinymce() {
      const tinymce = window.tinymce.get(this.tinymceId)
      if (this.fullscreen) {
        tinymce.execCommand('mceFullScreen')
      }

      if (tinymce) {
        tinymce.destroy()
      }
    },
    setContent(value) {
		window.tinymce.get(this.tinymceId).setContent(value)
    },
    getContent() {
      window.tinymce.get(this.tinymceId).getContent()
    },
    imageSuccessCBK(arr) {
      const _this = this
      arr.forEach(v => {
        window.tinymce.get(_this.tinymceId).insertContent(`<img class="wscnph" src="${v.url}" >`)
      })
    }
  }
}
</script>
<style scoped>
.tinymce-container {
  position: relative;
  line-height: normal;
}
.tinymce-container>>>.mce-fullscreen {
  z-index: 10000;
}
.tinymce-textarea {
  visibility: hidden;
  z-index: -1;
}
.editor-custom-btn-container {
  position: absolute;
  right: 4px;
  top: 4px;
  /*z-index: 2005;*/
}
.fullscreen .editor-custom-btn-container {
  z-index: 10000;
  position: fixed;
}
.editor-upload-btn {
  display: inline-block;
}
</style>
